import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  popup: {
    color: theme.palette.primary.main,
    padding: 16,

    '&.mapboxgl-popup-anchor-bottom .mapboxgl-popup-content': {
      backgroundColor: theme.palette.background.default,
      borderRadius: 8,
    },
    '&.mapboxgl-popup-anchor-bottom .mapboxgl-popup-close-button': {
      width: 24,
      height: 24,
      fontSize: 24,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  popupContent: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 6,
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
}));
